import { Reveal, SectionBadge } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export default function Manifesto() {
  const { t } = useLang();
  const chapters = t("manifesto.chapters");

  return (
    <section id="philosophy" data-testid="manifesto-section" className="py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionBadge label={t("manifesto.badge")} testId="manifesto-badge" />
          <h2 className="font-display mt-5 max-w-2xl text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-[#EAE6E1]">
            {t("manifesto.heading")}
          </h2>
          <p className="mt-4 max-w-xl text-base text-[#9E9E9E] leading-relaxed">
            {t("manifesto.sub")}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
          {chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.1}>
              <div
                data-testid={`manifesto-chapter-${i}`}
                className="group h-full rounded-xl border border-[#262930] bg-[#121418] p-4 md:p-7 transition-colors duration-200 hover:border-[#3A3F4B] hover:bg-[#181A20]"
              >
                <div className="font-tech text-[8px] md:text-[10px] uppercase tracking-[0.15em] md:tracking-[0.2em] text-[#C87A5B]">
                  {t("manifesto.chapterLabel")} {ch.num}
                </div>
                <h3 className="font-display mt-3 md:mt-4 text-base md:text-xl font-semibold tracking-tight text-[#EAE6E1]">
                  {ch.title}
                </h3>
                <p className="mt-2 md:mt-3 text-xs md:text-sm leading-relaxed text-[#9E9E9E]">{ch.body}</p>
                <div className="mt-4 md:mt-6 h-px w-full bg-[#262930] transition-colors duration-200 group-hover:bg-[#8C9A86]" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
